var _path, _circle, _circle2, _path2, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmojiNeutral(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Emoji Neutral") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "neutralAccent1",
    d: "m32.3 45.6l0.4-0.2c2.3-1.1 4-2 5.1-2.8 1-0.7 2.3-1.9 3.8-3.5l0.3-0.3c2.6-3.1 4.3-6.8 5-10.7 2.2-12.4-6.1-24.3-18.5-26.5-6.1-1 0.7-0.6 1.6 9.2s-0.2 16-3.8 21.5c-6.2 9.5-18.3 12.3-5.9 14.5 4 0.7 8.2 0.3 12-1.2z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "neutralSecondaryBrand",
    cx: 16.2,
    cy: 18.6,
    r: 2.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "neutralSecondaryBrand",
    cx: 31.4,
    cy: 18.6,
    r: 2.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "neutralSecondaryBrand",
    d: "m36.3 44.3c0.9-0.5 1.2-1.7 0.6-2.6-0.5-0.9-1.7-1.2-2.6-0.6-3.1 1.9-6.7 2.9-10.4 2.9-11.1 0-20.1-9-20.1-20.1s9.1-20 20.2-20 20.1 9 20.1 20.1c0 4-1.2 7.8-3.4 11.1-0.6 0.9-0.3 2 0.5 2.6 0.9 0.6 2 0.3 2.6-0.5 2.6-3.9 4-8.5 4-13.2 0-6.3-2.5-12.3-7-16.8s-10.5-7-16.8-7-12.3 2.5-16.8 7-7 10.5-7 16.8 2.5 12.3 7 16.8 10.5 7 16.8 7c4.3 0 8.6-1.2 12.3-3.5z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "neutralSecondaryBrand",
    x: 13.6,
    y: 29.1,
    width: 20.4,
    height: 3.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmojiNeutral);
export default __webpack_public_path__ + "static/media/emoji-neutral.e013be4b97da912681ee53709b124c0a.svg";
export { ForwardRef as ReactComponent };